// AI Generated Component
import { Component, OnInit, inject } from '@angular/core';
import { StateService } from '@uirouter/core';
import { SpellingRepoService } from '@client/app/services/api/spelling-repo/spelling-repo.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'spelling-pages-with-error',
    standalone: false,
    template: `
        <page-header
                [icon]="['QA', 'SPELLCHECK_PAGES'] | monIcons"
                [header]="'Misspellings by Page' | translate"
                [subHeader]="subheaderTranslation">
        </page-header>
        <mon-tabs
                [options]="tabs"
                [(status)]="activeTab"
                (onStatus)="onStatus($event)"
                (onSearch)="onSearch($event)"
                [search]="search"
                [minSearchLength]="1"
                [showSearch]="true"
                [showFiltersBtn]="showFilters"
                [(isFiltersOpen)]="isFiltersOpen">
        <csv-export-button [exports]="exports"></csv-export-button>
        </mon-tabs>
        <div class="card panel-monsido-card">
            <div class="card-body">
                <pages-misspellings-table
                        [currentSort]="currentSort"
                        [pages]="pages"
                        [progress]="progress"
                        (onSortPageChange)="onMonTableSort($event)"
                        (onPageChange)="onPageChange($event)"
                        (onPerPageChange)="onPageSizeChange($event)"
                        (callBack)="onPageDetailsClose()"
                        [(isFiltersOpen)]="isFiltersOpen"
                        (onFiltersChanges)="onFiltersChanges($event)">
                </pages-misspellings-table>
            </div>
        </div>
    `,
})
export class SpellingPagesWithErrorComponent extends BaseContainerComponentController implements OnInit {
    pages: any[] = [];
    domainId: any;
    progress: any = null;
    subheaderTranslation: string = '';
    type: any;
    exports: any[] = [];
    tabs: any[] = [];

    override spellingRepoService = inject(SpellingRepoService);
    translateService = inject(TranslateService);
    override pipeService = inject(PipeService);

    constructor (
        private stateService: StateService,
    ) {
        super({ table: true, labels: true, pages: true });
    }

    ngOnInit () {
        this.search = '';
        this.pages = [];
        this.domainId = this.stateService.params.domainId;
        this.progress = null;
        this.subheaderTranslation = '';

        this.currentSort = { by: 'priority_score', direction: 'desc' };

        this.exports = [
            {
                name: this.translateService.getString('Misspellings by Page'),
                data: {
                    category: 'pages_with_misspelling',
                },
            },
        ];

        this.tabs = [
            {
                name: 'All',
                faIcon: 'fas fa-language',
                value: 'all',
            },
            {
                name: this.translateService.getString('Misspellings'),
                faIcon: 'fas fa-language',
                value: 'confirmed',
            },
            {
                name: this.translateService.getString('Potential misspellings'),
                faIcon: 'fas fa-language',
                value: 'potential',
            },
        ];
        this.activeTab = 'all';

        this.getPage();
    }

    override getPage () {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            search: this.search ?? '',
            classification: this.activeTab === 'all' ? null : this.activeTab,
            type: this.type,
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
        };

        const updatedParams = this.updateParamsWithFilters(params);

        this.progress = this.spellingRepoService.getAllPages(updatedParams).then((data: any) => {
            this.pages = data;
            this.getSubHeaderDescription();
        }, () => {});
    }

    getSubHeaderDescription () {
        this.subheaderTranslation = this.translateService.getPlural(
            this.pipeService.get('monNumber')((this.pages as any).total || 0, '0,0'),
            '1 page',
            '[[count]] pages',
            { count: (this.pages as any).total || 0 },
            (this.pages as any).total || 0,
        );
    }

    onFiltersChanges (changes: any) {
        this.updateFilters(changes);
        this.getPage();
    }
}
